let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9NcCG")).then(() => parcelRequire('976s5'));